import { RefreshableHttpServiceConfigurator } from '../../../../../../submodules/web-shared/services/http-service/refreshable-http-service-configurator';

export class LocationHttpServiceConfigurator extends RefreshableHttpServiceConfigurator {

  getHttpClientConfig() {
    const baseConfig = super.getHttpClientConfig();
    return {
      ...baseConfig,
      baseURL: process.env.LOCATION_URL || '',
    };
  }
}
